import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FabricanteListarComponent } from './fabricante-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: FabricanteListarComponent }
    ])],
    exports: [RouterModule]
})
export class FabricanteListarRoutingModule { }
